import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home-page" }


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

// 首页 - 暂无功能

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "security-banner" }, [
      _createElementVNode("span", { class: "security-banner__icon" }, " ! "),
      _createElementVNode("span", { class: "security-banner__text" }, "严禁上传、处理、发送、转发涉密信息！")
    ], -1),
    _createElementVNode("div", { class: "welcome-text" }, "欢迎使用建研国检智能检测系统", -1)
  ])))
}
}

})